import { useState } from "react";
import { pricing, faqs } from "@/mocks/home";

type Props = { onOpenConsult: () => void };

export default function SectionPricingFaq({ onOpenConsult }: Props) {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="pricing" className="relative py-space-ds-section-standard md:py-space-ds-section-standard-md bg-white">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Pricing */}
          <div className="lg:col-span-7">
            <div className="text-ds-eyebrow text-ink-muted mb-space-ds-intro-eyebrow-heading">
              07 · Pricing
            </div>
            <h2 className="text-ds-section font-medium text-ink max-w-[440px]">
              Clear pricing, before you decide.
            </h2>

            <ul className="mt-10 border-t border-gray-200">
              {pricing.map((p) => (
                <li key={p.name} className="flex items-baseline justify-between py-space-ds-list-row border-b border-gray-200">
                  <span className="text-ds-body-lg text-ink">{p.name}</span>
                  <span className="text-ds-body-lg text-brand font-medium">{p.price}</span>
                </li>
              ))}
            </ul>

            <p className="mt-6 text-ds-caption text-ink-muted max-w-[420px]">
              Final treatment plans and costs are confirmed after consultation.
            </p>

            <button
              onClick={onOpenConsult}
              className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-brand text-white text-ds-control font-medium hover:bg-[#027ea3] transition whitespace-nowrap cursor-pointer"
            >
              Ask About My Treatment Cost
              <i className="ri-arrow-right-line text-sm" />
            </button>
          </div>

          {/* FAQ */}
          <div className="lg:col-span-5">
            <div className="text-ds-eyebrow text-ink-muted mb-space-ds-intro-eyebrow-heading">
              FAQ
            </div>
            <h2 className="text-ds-section font-medium text-ink max-w-[380px] mb-10">
              A few things patients often ask.
            </h2>

            <div className="border-t border-gray-200">
              {faqs.map((f, i) => {
                const isOpen = openIdx === i;
                return (
                  <div key={f.q} className={`border-b border-gray-200 ${isOpen ? "bg-accent2-soft" : ""}`}>
                    <button
                      onClick={() => setOpenIdx(isOpen ? -1 : i)}
                      className="w-full flex items-center gap-4 py-space-ds-list-row text-left cursor-pointer"
                    >
                      <span className={`flex-1 text-ds-body ${isOpen ? "text-ink" : "text-ink"}`}>
                        {f.q}
                      </span>
                      <span className={`w-8 h-8 flex items-center justify-center transition ${isOpen ? "text-brand rotate-45" : "text-ink-muted"}`}>
                        <i className="ri-add-line text-lg" />
                      </span>
                    </button>
                    <div className={`grid transition-all duration-400 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                      <div className="overflow-hidden">
                        <p className="pb-5 pr-10 text-ds-body-sm text-ink-muted">
                          {f.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}